module.exports = __webpack_public_path__ + "static/media/S30_W.734f02bc.png";